import { get } from "lodash";

export const MF_LABEL = 'SF';

export const METRIC_FILTER_TYPES = {
  bound: 'bound',
  error: 'error-code',
  boolean: 'boolean',
};

const parseBound = (value, unit) => {
  switch (unit) {
    case 'Kbps':
    case 'sec':
    case 'ms':
    case 'min':
    case 'fps':
    case 'ratio':
    case '%':
    case 'unitless': {
      // middle value
      if (value.includes('-')) {
        return value.split('-').map(Number);
      }
      // last value
      else if (value.includes('>=')) {
        const val = Number(value.slice(2));
        return [val, val];
      }
      // last value
      else if (value.includes('>')) {
        const val = Number(value.slice(1));
        return [val, val];
      }
      // first value
      else {
        return [Number(value), Number(value)];
      }
      break;
    }
    // default behaviour
    case '': {
      break;
    }
  }

  return value;
}

// input:  LifePlayingTimeMs ["300000-600000", "1800000-2400000"]
/* output:
  {
    "type": "bound",
    "dimension": "LifePlayingTimeMs",
    "lower": 300000,
    "upper": 600000
  },
*/
export function buildMetricFilter({ metric, data, range, distributionConfig }) {
  // data format  Array [ "300000-600000", 800 ]
  const bounds = [
    data[range[0]][0],
    data[range[1]][0],
  ];
  const upperLimit = range[1] === data.length-1;
  const lowerLimit = range[0] === 0;

  // skip filtering on full chart slice
  if(upperLimit && lowerLimit) {
    return null;
  }

  const { xAxisUnit, dimension } = distributionConfig;
  const [lower, _] = parseBound(bounds[0], xAxisUnit);
  const [__, upper] = parseBound(bounds[1], xAxisUnit);

  const rule:any = { type: 'bound', dimension: dimension };
  if(!upperLimit) {
    rule.upper = upper;
  }

  if(!lowerLimit) {
    rule.lower = lower;
  }

  return {
    metric,
    rule,
    meta: { range, type: METRIC_FILTER_TYPES.bound }
  };
}

export const getMetricFilterId = ({ metric, meta = {} }) => {
  // defaulting to bound to handle save/shared dashboard with MF (pre meta.type)
  const type = get(meta, 'type', METRIC_FILTER_TYPES.bound);
  return `mf-${metric}-${type}`;
}

export const hasErrorCode = (metricFilter) => {
  return metricFilter.some( (f) => {
    const type = get(f, 'meta.type', METRIC_FILTER_TYPES.bound);
    return type === METRIC_FILTER_TYPES.error;
  });
}
